export default __webpack_public_path__ + "328dbd5b45136af6bdce7f39387fdb26.jpg";